<template>
  <div class="home-page" @scroll="handleScroll">
    <!-- 头部-->
    <HomeHeader :scrollTop="scrollTop"></HomeHeader>
    <!-- 让世界发现你-->
    <HomeTitle></HomeTitle>
    <!-- src/assets/images/home/banner_title.png-->
    <!-- 入驻条件-->
    <HomeCondition></HomeCondition>
    <!-- 入驻流程-->
    <HomeProcess></HomeProcess>
    <!-- MCN机构-->
    <HomeMcn v-if="false"></HomeMcn>
    <!-- 底部footer-->
    <HomeFooter></HomeFooter>
  </div>
</template>

<script>
import HomeHeader from "@/views/home/components/home-header";
import HomeTitle from "@/views/home/components/home-title";
import HomeCondition from "@/views/home/components/home-condition";
import HomeProcess from "@/views/home/components/home-process";
import HomeMcn from "@/views/home/components/home-mcn";
import HomeFooter from "@/views/home/components/home-footer";

export default {
  name: "home",
  components: {
    HomeHeader,
    HomeTitle,
    HomeCondition,
    HomeProcess,
    HomeMcn,
    HomeFooter
  },
  data() {
    return {
      scrollTop: 0
    }
  },
  created() {
    this.$store.commit('common/setToken', '')
    this.$store.commit('common/setApplyId', '')
  },
  methods: {
    handleScroll(event) {
      this.scrollTop = event.target.scrollTop
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  height: 100vh;
  overflow-y: auto;
  background-image: url("~@/assets/banner.png");
  background-size: 100% 600px;
  background-repeat: no-repeat;
}
</style>